import { combineReducers, Reducer } from 'redux';
import * as fromActions from '../Actions/Actions';
import { IGameState } from '../Store/store';
import { StateBoard } from './board';
import { StateBoosters } from './boosters';
import { StateCurrency } from './currency';
import { StateLevel } from './level';
import { StatePlayer } from './player';
import { StateScore } from './score';
import { StateSocial } from './social';
import { StateSound } from './sound';
import { StateTracking } from './tracking';
import { StateTutorial } from './tutorial';
import { StateView } from './view';
import { StateMissions } from './missions';
import { StatePause } from './pause';

const reducers = combineReducers({
    StateBoard,
    StateBoosters,
    StateCurrency,
    StateLevel,
    StateMissions,
    StatePause,
    StatePlayer,
    StateScore,
    StateSocial,
    StateSound,
    StateTracking,
    StateTutorial,
    StateView,
});

// @ts-ignore
export let lastAction;

const collected: Reducer<IGameState, fromActions.Actions> = (state, action) => {
    const newState = reducers(state, action);

    lastAction = action;

    return newState;
};

export default collected;
